module.exports = __webpack_public_path__ + "static/img/anastasiia-tarasova-Tjs4qGXgws0-unsplash_thumb.4ed3e2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/anastasiia-tarasova-Tjs4qGXgws0-unsplash_thumb.png
// module id = w2nw
// module chunks = 4